export var ProductVariationType = /*#__PURE__*/ function(ProductVariationType) {
    ProductVariationType["CUSTOM"] = "CUSTOM";
    ProductVariationType["SIZE"] = "SIZE";
    ProductVariationType["COLOR"] = "COLOR";
    ProductVariationType["LANGUAGE"] = "LANGUAGE";
    return ProductVariationType;
}({});
